import { Link } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import '../App.css';
import Footer from './footer';
import categoryTest from './categoryTest';

function Home() {

    const buttonTest = categoryTest.map(item => (
        <Col md={4} key={item.id} className='div_button'>
            <Link to={item.ranks}>
                <div className='div_img'><img src={item.image} className='button_img'></img></div>
                <div className='text5'>{item.category}</div>
            </Link>
            <div className='button_hr'></div>
        </Col>
    ));
    return (
        <div className="Home">
            <Link to='/'><div className='div_home_img'><img className='home_img' src='./test.png'></img></div></Link>
            <Container fluid>
                <Row>
                    <Col sm={2}></Col>
                    <Col sm={8}>
                        <div className='text1'>מבחני תיאוריה</div>
                        <div className='text2'>האתר מספק מבחנים המדמים מבחני תאוריה, לכל סוגי הרשיונות, ובחינם!</div>
                        <div className='text3'>מבנה מבחן התאוריה ושאלותיו מבוססים על המבחנים של משרד התחבורה, במטרה להכין את הלומדים בצורה הטובה ביותר.</div>
                        <div className='text4'>בהצלחה בהמשך הלימודים!</div>
                    </Col>
                    <Col sm={2}></Col>
                </Row>
            </Container>
            <Container fluid className='home_button'>
                <Row>
                    <Col sm={2}></Col>
                    <Col sm={8}>
                        <Row>
                            {buttonTest}
                        </Row>
                    </Col>
                    <Col sm={2}></Col>
                </Row>
            </Container>
            <div className='footer'>
                <Footer />
            </div>
        </div>
    );
}

export default Home;